import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { QuotationFormComponent } from '../quotation-form/quotation-form.component';
import { OfferBadgeComponent } from './offer-badge.component';
import { DiscountAnimationComponent } from './discount-animation.component';
import { MotionBackgroundComponent } from '../shared/motion-background.component';
import { RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ScrollAnimationDirective,
    OfferBadgeComponent,
    DiscountAnimationComponent,
    MotionBackgroundComponent,
    RouterLink,
    TranslateModule
  ],
  template: `
    <section class="section offer-section">
      <app-motion-background></app-motion-background>
      <div class="container">
        <div class="offer-content" scrollAnimation>
          <app-offer-badge></app-offer-badge>

          <h2 class="offer-title">{{ offerTitle }}</h2>

          <div class="offer-cards">
            <div class="offer-card discount-card">
              <app-discount-animation [percentage]="50"></app-discount-animation>
              <p class="discount-text">{{ discountText }}</p>
            </div>

            <div class="offer-card timer-card">
              <mat-icon class="timer-icon">timer</mat-icon>
              <h3 class="timer-title">{{ timerTitle }}</h3>
              <p class="timer-text">{{ timerText }}</p>
            </div>
          </div>

          <div class="cta-container">
            <button mat-raised-button class="cta-button primary"  [routerLink]="['/index/register']">
              <mat-icon>rocket_launch</mat-icon>
              {{ ctaGetStarted }}
            </button>
            <button mat-raised-button class="cta-button primary" (click)="openDemoForm()">
              <mat-icon>play_circle</mat-icon>
              {{ ctaRequestDemo }}
            </button>
            <button mat-raised-button class="cta-button primary" (click)="openQuotationForm()">
              <mat-icon>request_quote</mat-icon>
              {{ ctaRequestQuotation }}
            </button>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .offer-section {
      background: #6a1b9a;
      color: white;
      padding: 3rem 0;
      position: relative;
      overflow: hidden;
    }

    .offer-content {
      text-align: center;
      max-width: 1000px;
      margin: 0 auto;
      position: relative;
      z-index: 1;
    }

    .offer-title {
      font-size: 3rem;
      margin: 2rem 0;
      font-weight: 700;
    }

    .offer-cards {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
      margin: 3rem 0;
    }

    .offer-card {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 20px;
      padding: 2.5rem;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      transition: transform 0.3s ease;
    }

    .offer-card:hover {
      transform: translateY(-5px);
    }

    .timer-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .timer-icon {
      font-size: 3.5rem;
      width: 3.5rem;
      height: 3.5rem;
      margin-bottom: 1.5rem;
      color: white;
    }

    .timer-title {
      font-size: 2rem;
      margin-bottom: 0.5rem;
      color: white;
    }

    .timer-text {
      font-size: 1.25rem;
      opacity: 0.9;
    }

    .discount-text {
      font-size: 1.5rem;
      margin-top: 1rem;
      opacity: 0.9;
    }

    .cta-container {
      display: flex;
      gap: 2rem;
      justify-content: center;
      margin-top: 3rem;
    }

    .cta-button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 1rem 2rem !important;
      font-size: 1.1rem !important;
      font-weight: 500 !important;
      border-radius: 12px !important;
    }

    .cta-button.primary {
      background: #e44891;
      color: white !important;
    }

    @media (max-width: 768px) {
      .offer-section {
        padding: 4rem 1rem;
      }

      .offer-title {
        font-size: 2.25rem;
      }

      .offer-cards {
        grid-template-columns: 1fr;
      }

      .cta-container {
        flex-direction: column;
        gap: 1rem;
      }

      .cta-button {
        width: 100%;
      }
    }
  `]
})
export class OfferComponent implements OnInit {
  offerTitle: string = '';
  discountText: string = '';
  timerTitle: string = '';
  timerText: string = '';
  ctaGetStarted: string = '';
  ctaRequestDemo: string = '';
  ctaRequestQuotation: string = '';

  constructor(private dialog: MatDialog, private _translate: TranslateService) {}

  ngOnInit(): void {
    this.offerTitle = this._translate.instant('OFFER.OFFER_TITLE');
    this.discountText = this._translate.instant('OFFER.DISCOUNT_TEXT');
    this.timerTitle = this._translate.instant('OFFER.TIMER_TITLE');
    this.timerText = this._translate.instant('OFFER.TIMER_TEXT');
    this.ctaGetStarted = this._translate.instant('OFFER.CTA_GET_STARTED');
    this.ctaRequestDemo = this._translate.instant('OFFER.CTA_REQUEST_DEMO');
    this.ctaRequestQuotation = this._translate.instant('OFFER.CTA_REQUEST_QUOTATION');
  }

  openDemoForm() {
    window.open('https://outlook.office365.com/owa/calendar/SystemDemo@5dma.vip/bookings/', '_blank');
  }

  openQuotationForm() {
    this.dialog.open(QuotationFormComponent, {
      width: '90%',
      maxWidth: '600px'
    });
  }

  // openGetStarted() {
  //   window.location.href = '#get-started';
  // }
}
